import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './BillImagePage.css';
import axios from 'axios';

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_PROXY_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

function BillImagePage() {
  const [billImages, setBillImages] = useState([]);
  const [loading, setLoading] = useState(true);

  const { customerId, taxid, taxyear } = useParams();

  useEffect(() => {
    const fetchBillImages = async () => {
      try {
        // Call the Node proxy route
        const response = await fetch(`${process.env.REACT_APP_PROXY_URL}/api/billImage/images/${customerId}/${taxid}/${taxyear}`);
        const data = await response.json();
        setBillImages(data);
      } catch (error) {
        console.error('Error fetching bill images:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBillImages();
  }, [customerId, taxid, taxyear]);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="billimage-page">
      <h1>{billImages.length} Tax bill image(s) found:</h1>
      {billImages.map((img, idx) => (
        <div className="billimage-item" key={idx}>
          <h3>
            Bill Image for document ({img.fileName}):
            {' '}
            <a href={img.base64Pdf} target="_blank" rel="noopener noreferrer">
              Tax Bill .pdf
            </a>
          </h3>
        </div>
      ))}
    </div>
  );
}

export default BillImagePage;